import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';

import GlobalStyle from '../components/globalStyle';
import ProjectCard from '../components/ProjectCard';
import VisitButton from '../components/VisitButton';

import profileImg from '../images/github-profile.png';
import storeImg from '../images/simple-store-demo.png';
import landingImg from '../images/landing-page-demo.png';
import chatImg from '../images/firechat-demo.png';

const IndexPage = ( props ) => {
  const data = useStaticQuery(graphql`
  query DBQuery {
    allData {
        edges {
        node {
            desc1
            desc2
            desc3
            desc4
            title1
            title2
            title3
            title4
        }
        }
    }
  }`);
  const dataText = data.allData.edges[0].node;

  const StyledTitle = styled.h1`
    display: flex;
    align-self: center;
  `

  const StyledDescription = styled.p`
    display: flex;
    flex-direction: row;
    width: 100%;
    @media (max-width: 43em) {
      flex-direction: column;
    }
    @media (min-width: 43em) and (max-width: 62em) {
      flex-direction: column;
    }
  `

  const StyledText = styled.div`
    display: flex;
    flex-direction: column;
    width: 50%;
    margin-top: 10%;
    @media (max-width: 43em) {
      text-align: center;
      width: 90%;
      margin: 0 auto;
    }
    @media (min-width: 43em) and (max-width: 62em) {
      flex-direction: column;
      text-align: center;
      margin: 5% auto;
    }
  `

  const StyledCTA = styled.p`
    width: 80%;
    font-size: 14px;
    margin: 0 auto;
    a {
      color: #337CA0;
      cursor: pointer;
      text-decoration: none;
    }
    @media (max-width: 43em) {
      text-align: center;
      width: 90%;
      margin: 1em auto 0;
    }
    @media (min-width: 43em) and (max-width: 62em) {
      margin-top: -18%;
    }
  `

  const StyledProfile = styled.div`
    display: flex;
    width: 80%;
    height: 213px;
    margin: 16px auto;
    background-image: url(${profileImg});
    background-size: contain;
    background-repeat: no-repeat;
    border: 1px solid #172121;
    @media (max-width: 43em) {
      width: 100%;
      height: 212px;
    }
    @media (min-width: 43em) and (max-width: 62em) {
      height: 216px;
      margin: 5% auto;
    }
  `

  const StyledStore = styled.div`
    display: flex;
    width: 40%;
    height: 213px;
    margin: 20% auto 0;
    background-image: url(${storeImg});
    background-size: contain;
    background-repeat: no-repeat;
    border: 1px solid #172121;
    @media (max-width: 43em) {
      width: 100%;
      height: 234px;
      margin: 10% auto;
    }
    @media (min-width: 43em) and (max-width: 62em) {
      height: 216px;
      margin: 5% auto;
    }
  `

  const StyledLanding = styled.div`
    display: flex;
    width: 40%;
    height: 213px;
    margin: 20% auto 0;
    background-image: url(${landingImg});
    background-size: contain;
    background-repeat: no-repeat;
    border: 1px solid #172121;
    @media (max-width: 43em) {
      width: 100%;
      height: 234px;
      margin: 10% auto;
    }
    @media (min-width: 43em) and (max-width: 62em) {
      height: 216px;
      margin: 5% auto;
    }
  `

  const StyledChat = styled.div`
    display: flex;
    width: 40%;
    height: 213px;
    margin: 20% auto 0;
    background-image: url(${chatImg});
    background-size: contain;
    background-repeat: no-repeat;
    border: 1px solid #172121;
    @media (max-width: 43em) {
      width: 100%;
      height: 234px;
      margin: 10% auto;
    }
    @media (min-width: 43em) and (max-width: 62em) {
      height: 216px;
      margin: 5% auto;
    }
  `

  return (
    <>
      <GlobalStyle />
      <ProjectCard>
        <div label="briefcase" color="#173753"> 
          <StyledTitle>{dataText.title1}</StyledTitle>
          <StyledDescription>
            <StyledText>
              {dataText.desc1}
            </StyledText>
            <StyledText>
              <StyledCTA>If you want to know a little more about me, just click <a href="https://github.com/Rafajrg21">here.</a> And take a look at my README</StyledCTA>
              <StyledProfile />
            </StyledText>
          </StyledDescription>
        </div> 

        <div label="store-alt" color="#00C49A"> 
          <StyledTitle>{dataText.title2}</StyledTitle>
          <StyledDescription>
            <StyledText>
              {dataText.desc2}
              <VisitButton 
                demoLink={"https://plain-store-c51i72w10.vercel.app/"} 
                ghLink={"https://github.com/Rafajrg21/Plain-Store"} 
              />
            </StyledText>
            <StyledStore />
          </StyledDescription>
        </div> 
        
        <div label="plane-arrival" color="#FB8F67"> 
          <StyledTitle>{dataText.title3}</StyledTitle>
          <StyledDescription>
            <StyledText>
              {dataText.desc3}
              <VisitButton 
                demoLink={"https://coffeeman-landing-ie3szpfo2.vercel.app/"} 
                ghLink={"https://github.com/Rafajrg21/coffeeman-landing"} 
              />
            </StyledText>
            <StyledLanding />
          </StyledDescription>
        </div> 
      
        <div label="comment" color="#C03221"> 
          <StyledTitle>{dataText.title4}</StyledTitle>
          <StyledDescription>
            <StyledText>
              {dataText.desc4}
              <VisitButton 
                demoLink={"https://priceless-wescoff-69cb84.netlify.app/"} 
                ghLink={"https://github.com/Rafajrg21/Firechat"} 
              />
            </StyledText>
            <StyledChat />
          </StyledDescription>
        </div> 
      </ProjectCard>
    </>
  )
}

export default IndexPage